import React from 'react'
import translate from '../../reusable/translate'

const PrimaryButton = ({ textKey, disabled, action, languageOverride }) => {
    return(
        <div className="flex-column">
            <button
                className={ `add-button ${disabled ? 'add-button-disabled' : ''}`}
                disabled={disabled}
                onClick={action}
            >
                {translate({ textKey: textKey, languageOverride: languageOverride })}
            </button>
        </div>)
}

export default PrimaryButton


// WEBPACK FOOTER //
// ./src/components/materialCommitment/buttons/PrimaryButton.jsx